export default "__VITE_ASSET__CkFy5qFi__"